var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AppButtonOk',{attrs:{"disabled":_vm.currentStep >= _vm.steps.length,"color":_vm.color},on:{"click":_vm.onClickNext}},[_c('v-icon',{attrs:{"color":_vm.btnColor,"large":""}},[_vm._v("mdi-menu-right")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }